import { curry } from 'lib/util'
import deleteWithDrafts from 'app/_shared/events/model/deleteWithDrafts'
import { back } from 'app/_shared/events'

/**
 * Attempts to delete local draft and corresponding remote pin or option objects.
 *
 * @param module    current module
 * @param component event source
 * @param event     triggered event
 */
const deletePinOrOptionWithDrafts = async (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: Gaia.PlatformEvent,
) => {
  const type = module[G.MODEL][G.CHILDREN]?.type?.[G.CACHE] || 'option'

  await deleteWithDrafts({
    ns: 'optionManagement',
    type,
    alsoDraft: true,
    optimistic: true,
    onSuccess: back,
  })(module, component, event)
}

export default curry(deletePinOrOptionWithDrafts)
